import React from "react";

const NavigationCard = ({Icon, total_notification, RedirectLocation, Title, Description, FooterText, UsedFor}) => {
    return (
        <div
            className="discountImage cardGap mt-5"
            onClick={() => {
                window.location.href = RedirectLocation;
            }}
        >
            {/* <img src={restaurant} alt="" className="img-fluid image-Discount" /> */}
            <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                    <div className="offer-Text">
                        {/* <h2><b>Create restaurant</b></h2> */}
                    </div>
                </div>
            </div>
            <div className="CardTitle" style={{ right: UsedFor === "OrderHistoryLog" ? "17%" : "32%", }}>
                {UsedFor === "OrderHistoryLog"}
                <h5 style={{ textAlign: "center" }}>{Title}</h5>
            </div>
            <div className="CardDetails">
                <p>{Description}</p>
            </div>

            <div className="iconPosition" style={{ top: "-18%" }}>
                <div className="circle">
                    <img
                        src={Icon}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                    />
                </div>
            </div>
            {total_notification > 0 ? (
                <div className="rounded-CircleIcon">{total_notification}</div>
            ) : null}
            <div className="d-flex justify-content-center cardButton">
                <h6>{FooterText}</h6>
            </div>
        </div>
    );
};

export default NavigationCard;
